export default __webpack_public_path__ + "static/media/company-closer.9616d334.svg";